const dashboardWorkflowsPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'dashboard-workflows' : '/dashboard-workflows';

const dashboardResourceUsagePath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'dashboard-resource-usage' : '/dashboard-resource-usage';

const dashboardDatasetsPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'dashboard-data-sets' : '/dashboard-data-sets';

const dashboardGeneralPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'dashboard-general' : '/dashboard-general';

const dashboardDdiPath = (isDefaultPath?: boolean): string => (!isDefaultPath ? 'dashboard-ddi' : '/dashboard-ddi');

const dashboardTransferStatusStagePath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'dashboard-stage-transfer-statuses' : '/dashboard-stage-transfer-statuses';

const dashboardTransferStatusDeletePath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'dashboard-delete-transfer-statuses' : '/dashboard-delete-transfer-statuses';

const workflowListPath = (isDefaultPath?: boolean): string => (!isDefaultPath ? 'workflows' : '/workflows');

const workflowCreatePath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'workflows/create-custom' : '/workflows/create-custom';

const workflowDetailsPath = (workflowId?: string): string => {
    return !workflowId ? 'workflows/:workflowId/details' : `/workflows/${workflowId}/details`;
};

const workflowExecutePath = (workflowId?: string): string => {
    return !workflowId ? 'workflows/:workflowId/details/execute' : `/workflows/${workflowId}/details/execute`;
};

const workflowExecutionDetailsPath = (workflowId?: string, workflowExId?: string): string => {
    return !workflowId || !workflowExId
        ? 'workflows/:workflowId/details/:workflowExId/details'
        : `/workflows/${workflowId}/details/${workflowExId}/details`;
};

const workflowExecutionReExecutePath = (workflowId?: string, workflowExId?: string): string => {
    return !workflowId || !workflowExId
        ? 'workflows/:workflowId/details/:workflowExId/re-execute'
        : `/workflows/${workflowId}/details/${workflowExId}/re-execute`;
};

const workflowExecutionLogsPath = (workflowId?: string, workflowExId?: string, taskId?: string): string => {
    return !workflowId || !workflowExId || !taskId
        ? 'workflows/:workflowId/details/:workflowExId/details/:taskId/logs'
        : `/workflows/${workflowId}/details/${workflowExId}/details/${taskId}/logs`;
};

const workflowCreateContainerListPath = (shortName?: string): string =>
    !shortName ? 'workflows/:shortName/create-from-container' : `/workflows/${shortName}/create-from-container`;

const workflowCreateContainerConfigPath = (shortName?: string, dataSetId?: string): string => {
    return !shortName || !dataSetId
        ? 'workflows/:shortName/create-from-container/:dataSetId'
        : `/workflows/${shortName}/create-from-container/${dataSetId}`;
};

const workflowCreateHpcAppListPath = (shortName?: string): string =>
    !shortName ? 'workflows/:shortName/create-from-hpc-app' : `/workflows/${shortName}/create-from-hpc-app`;

const workflowCreateHpcAppConfigPath = (shortName?: string, commandTemplateName?: string): string => {
    return !shortName || !commandTemplateName
        ? 'workflows/:shortName/create-from-hpc-app/:commandTemplateName'
        : `/workflows/${shortName}/create-from-hpc-app/${commandTemplateName}`;
};

const workflowCreateJobScriptListPath = (shortName?: string): string =>
    !shortName ? 'workflows/:shortName/create-from-job-script' : `/workflows/${shortName}/create-from-job-script`;

const workflowCreateJobScriptConfigPath = (shortName?: string, dataSetId?: string): string => {
    return !shortName || !dataSetId
        ? 'workflows/:shortName/create-from-job-script/:dataSetId'
        : `/workflows/${shortName}/create-from-job-script/${dataSetId}`;
};

const datasetListPath = (isDefaultPath?: boolean): string => (!isDefaultPath ? 'data-sets' : '/data-sets');

const datasetDetailsPath = (dataSetId?: string): string => {
    return !dataSetId ? 'data-sets/:dataSetId/details' : `/data-sets/${dataSetId}/details`;
};

const datasetUpdatePath = (dataSetId?: string): string => {
    return !dataSetId ? 'data-sets/:dataSetId/update' : `/data-sets/${dataSetId}/update`;
};

const datasetFileListPath = (dataSetId?: string): string => {
    return !dataSetId ? 'data-sets/:dataSetId/details/file-list' : `/data-sets/${dataSetId}/details/file-list`;
};

const datasetEditFilePath = (dataSetId?: string, filePath?: string): string => {
    return !dataSetId || !filePath
        ? 'data-sets/:dataSetId/details/file-list/:filePath/edit'
        : `/data-sets/${dataSetId}/details/file-list/${filePath}/edit`;
};

const datasetUploadPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'data-sets/upload' : '/data-sets/upload';

const datasetCreateEmptyPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'data-sets/empty-upload' : '/data-sets/empty-upload';

const projectListPath = (isDefaultPath?: boolean): string => (!isDefaultPath ? 'projects' : '/projects');

const projectOwnRequestsPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'projects/own-requests' : '/projects/own-requests';

const projectDetailsPath = (shortName?: string): string => {
    return !shortName ? 'projects/:shortName/details' : `/projects/${shortName}/details`;
};

const projectAccessRequestsPath = (shortName?: string): string => {
    return !shortName
        ? 'projects/:shortName/details/access-requests'
        : `/projects/${shortName}/details/access-requests`;
};

const projectResourceRequestsPath = (shortName?: string): string => {
    return !shortName
        ? 'projects/:shortName/details/resource-requests'
        : `/projects/${shortName}/details/resource-requests`;
};

const projectManageTagsPath = (shortName?: string): string => {
    return !shortName ? 'projects/:shortName/details/manage-tags' : `/projects/${shortName}/details/manage-tags`;
};

const projectUsersPath = (shortName?: string): string => {
    return !shortName ? 'projects/:shortName/details/users' : `/projects/${shortName}/details/users`;
};

const projectResourcesPath = (shortName?: string): string => {
    return !shortName ? 'projects/:shortName/details/resources' : `/projects/${shortName}/details/resources`;
};

const projectCommandTemplatesMgmtPath = (shortName?: string): string => {
    return !shortName
        ? 'projects/:shortName/details/command-templates'
        : `/projects/${shortName}/details/command-templates`;
};

const projectResourceUsagePath = (shortName?: string, resourceName?: string): string => {
    return !shortName || !resourceName
        ? 'projects/:shortName/details/resources/:resourceName/resource-usage'
        : `/projects/${shortName}/details/resources/${resourceName}/resource-usage`;
};

const userProfilePath = (isDefaultPath?: boolean): string => (!isDefaultPath ? 'profile' : '/profile');

const userExpirioPath = (isDefaultPath?: boolean): string => (!isDefaultPath ? 'profile/expirio' : '/profile/expirio');

const mgmtUsersPath = (isDefaultPath?: boolean): string => (!isDefaultPath ? 'management-users' : '/management-users');

const mgmtProvidersPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'management-providers' : '/management-providers';

const mgmtLocationsPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'management-locations' : '/management-locations';

const mgmtResourcesPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'management-resources' : '/management-resources';

const mgmtResourceAssignmentsPath = (resourceId?: string): string => {
    return !resourceId
        ? 'management-resources/:resourceId/assignments'
        : `/management-resources/${resourceId}/assignments`;
};

const mgmtResourceRequestsPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'management-resource-requests' : '/management-resource-requests';

const mgmtProjectRequestsPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'management-project-requests' : '/management-project-requests';

const mgmtKillSwitchPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'management-kill-switch' : '/management-kill-switch';

const mgmtCommandTemplatesPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'management-command-templates' : '/management-command-templates';

const mgmtKillSwitchDetailPath = (providerName?: string, locationName?: string): string => {
    return !providerName || !locationName
        ? 'management-kill-switch/:providerName/:locationName'
        : `/management-kill-switch/${providerName}/${locationName}`;
};

const containerListPath = (isDefaultPath?: boolean): string => (!isDefaultPath ? 'containers' : '/containers');

const containerCreatePath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'containers/create' : '/containers/create';

const containerUpdatePath = (dataSetId?: string): string => {
    return !dataSetId ? 'containers/:dataSetId/update' : `/containers/${dataSetId}/update`;
};

const containerDetailsPath = (dataSetId?: string): string => {
    return !dataSetId ? 'containers/:dataSetId/details' : `/containers/${dataSetId}/details`;
};

const jobScriptsListPath = (isDefaultPath?: boolean): string => (!isDefaultPath ? 'job-scripts' : '/job-scripts');

const jobScriptCreatePath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'job-scripts/create' : '/job-scripts/create';

const jobScriptDuplicatePath = (dataSetId?: string): string => {
    return !dataSetId ? 'job-scripts/:dataSetId/duplicate' : `/job-scripts/${dataSetId}/duplicate`;
};

const jobScriptExecutionLogsPath = (workflowId?: string, workflowExId?: string, taskId?: string): string => {
    return !workflowId || !workflowExId || !taskId
        ? 'job-scripts/:workflowId/executions/:workflowExId/details/:taskId/logs'
        : `/job-scripts/${workflowId}/executions/${workflowExId}/details/${taskId}/logs`;
};

const error404Path = (isDefaultPath?: boolean): string => (!isDefaultPath ? '404' : '/404');

const error500Path = (isDefaultPath?: boolean): string => (!isDefaultPath ? '500' : '/500');

const underConstructionPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'under-construction' : '/under-construction';

const mailResourceRequestPath = (requestId?: string): string => {
    return !requestId ? 'resource-request/:requestId' : `/resource-request/${requestId}`;
};

const remoteFileManagerPath = (isDefaultPath?: boolean): string =>
    !isDefaultPath ? 'remote-file-manager' : '/remote-file-manager';

export {
    dashboardWorkflowsPath,
    dashboardResourceUsagePath,
    dashboardDatasetsPath,
    dashboardGeneralPath,
    dashboardDdiPath,
    dashboardTransferStatusStagePath,
    dashboardTransferStatusDeletePath,
    workflowListPath,
    workflowCreatePath,
    workflowDetailsPath,
    workflowExecutePath,
    workflowExecutionDetailsPath,
    workflowExecutionReExecutePath,
    workflowExecutionLogsPath,
    workflowCreateContainerListPath,
    workflowCreateContainerConfigPath,
    workflowCreateHpcAppListPath,
    workflowCreateHpcAppConfigPath,
    workflowCreateJobScriptListPath,
    workflowCreateJobScriptConfigPath,
    datasetListPath,
    datasetDetailsPath,
    datasetUpdatePath,
    datasetFileListPath,
    datasetEditFilePath,
    datasetUploadPath,
    datasetCreateEmptyPath,
    projectListPath,
    projectOwnRequestsPath,
    projectDetailsPath,
    projectAccessRequestsPath,
    projectResourceRequestsPath,
    projectManageTagsPath,
    projectUsersPath,
    projectResourcesPath,
    projectCommandTemplatesMgmtPath,
    projectResourceUsagePath,
    userProfilePath,
    userExpirioPath,
    mgmtUsersPath,
    mgmtProvidersPath,
    mgmtLocationsPath,
    mgmtResourcesPath,
    mgmtResourceAssignmentsPath,
    mgmtResourceRequestsPath,
    mgmtProjectRequestsPath,
    mgmtKillSwitchPath,
    mgmtKillSwitchDetailPath,
    mgmtCommandTemplatesPath,
    containerListPath,
    containerCreatePath,
    containerUpdatePath,
    containerDetailsPath,
    jobScriptsListPath,
    jobScriptCreatePath,
    jobScriptDuplicatePath,
    jobScriptExecutionLogsPath,
    error404Path,
    error500Path,
    underConstructionPath,
    mailResourceRequestPath,
    remoteFileManagerPath,
};
